import React, { useEffect, useState, useCallback } from "react";
import { getDocs, collection, doc , deleteDoc, updateDoc} from "firebase/firestore"
import { db, auth } from "../firebase-config";
import '../App.css';

function Home({isAuth}) {
    const [link, setlink] = useState("");
    const [postList, setpostList] = useState([]);
    const [t, setT] = useState("");

    const postsCollectionRef = collection(db, "Posts");

    const updatePost = useCallback(async (e) => {
        const postD = doc(db, "Posts", e);
        const temp = t;
        temp.push(auth.currentUser.displayName + ": " + link);
        await updateDoc(postD, {submit: temp});
      }, [link, t]);

    const deletePost = useCallback(async (e) => {
        const postDoc = doc(db, "Posts", e);
        await deleteDoc(postDoc);
        }, []);
    useEffect(() => {
    const getPosts = async () => {
        try {
        const data = await getDocs(postsCollectionRef);
        setpostList(data.docs.map((doc) => ({ ...doc.data(), e: doc.id })));
        } catch (error) {
        console.log(error);
        }
    };
    getPosts();
    }, [deletePost, t]);
    
    return (
        <div className = "App">
            {postList.map((post) => {
                return (
                    <div className="module">
                        <h1 className="title"> 
                            {post.title}
                        </h1> 
                        <div className="desc">
                            {post.description}
                        </div>
                        <h3 className="name">
                            {post.name}
                        </h3>
                        <div>
                            {isAuth && post.id === auth.currentUser.uid && (<button className="delete" onClick = {() => {
                                deletePost(post.e);
                            }}>DELETE POST</button>)}
                        </div>
                        <br></br>
                        <div>
                        {isAuth && post.id &&(
                            <>
                            <textarea className="area" placeholder="Type Response Here" onChange = {(event) => {
                                setT(post.submit);
                                setlink(event.target.value);
                                post.sumbit = t;
                            }}>  
                            </textarea>
                            <br></br>
                            
                            <button className="delete" onClick ={() =>{
                                if (t !== ""){
                                    setT(post.submit);
                                    updatePost(post.e);
                                    post.sumbit = t;
                                }
                            }}>
                                SUBMIT
                            </button>
                            </>)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default Home;
